import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class LocalLinearEmbeddingGraph  extends AbstractScatterVisualization {
}
